import React from 'react';
import styled from '@emotion/styled';
import { IAirline } from '@move-frontend/dap';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { Css, Responsive } from '../../../../../../ui';

interface IProps {
	icaoOperatingAirline: string;
	airlineDetails?: IAirline;
}

const styles = css`
	display: flex;
	gap: ${Css.pxToRem(8)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: none;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	padding-top: 0;
	padding-bottom: 0;
	align-items: center;
`;

export const AirlineName = styled.span`
	padding-top: ${Css.pxToRem(8)};
	padding-bottom: ${Css.pxToRem(8)};
	font-size: ${Css.pxToRem(14)};
	font-weight: 300;
`;

export function Header() {
	return <StyledHeader>Airline</StyledHeader>;
}

export function Cell({ icaoOperatingAirline, airlineDetails }: IProps) {
	const logoSrc = airlineDetails?.squareLogo;
	const name = airlineDetails?.name || icaoOperatingAirline;

	return (
		<StyledCell>
			{logoSrc && (
				<img src={logoSrc} alt={name} width={32} height={32} loading="lazy" />
			)}

			<AirlineName>{name}</AirlineName>
		</StyledCell>
	);
}
